import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import { ToastController } from 'ionic-angular';

import * as moment from 'moment'
/*
  Generated class for the LeistungProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class LeistungProvider {
  public leistung = this.initLeistung();
  public leistungEdit = this.initLeistung();

  constructor(public http: Http,   
  	public toastCtrl: ToastController, 
	  private rhynoApi: RhynoApiProvider ) {
    console.log('Hello LeistungProvider Provider');

  }

  initLeistung(): any{
    let date        = moment();
  	//var date = new Date();
    //date.setHours(2, 0, 0, 0);

  	return {LEISTUNG_ID: '',
			ID: '',
			Leistung: '',
			Beschreibung: '',
			Zusatz: '',
			Typ: '0',
			Mitarbeiter: '', //this.rhynoApi.UserAccount.Mitarbeiter,
			MitarbeiterName: '', // this.rhynoApi.UserAccount.Name,
      Kunde: '',
			KundeName: '',
			Datum: date.format('YYYY-MM-DD'),
			ProjektID: '',
			ProjektIDExt: '',
			ProjektBezeichnung: '',
			Auftrag: '',
			Sprache: 'D',
			VonExtern: '', //
			BisExtern: '', //
			MengeExtern: 8,
			VonIntern: '',
			BisIntern: '',
			MengeIntern: 0, //
			PreisExtern: 0,
			PreisIntern: 0,
			Rabatt: 0,
			Verrechenbar: true,
			VerrechnetAm: '',
			Verrechnet: false,
			Kostenstelle: '',
			Kostentraeger: '',
			BelegpKennung: '',
			Basismengenfaktor: '1',
			Frei1: '',
			Frei2: '',
			FreiDatum: '',
			FreiZahl: '',
			AngelegtAm: '',
			AngelegtVon: 'fb',
			BearbeitetAm: '',
			BearbeitetVon: 'fb',
			Leistungstext: ''
			};
  }
  resetLeistung(){
    this.leistung.MengeExtern = 8;
    this.leistung.Leistungstext = '';
  }

  initLeistungFromInbox(data): any{
    let date        = moment();
    //var date = new Date();
    //date.setHours(2, 0, 0, 0);

    return {LEISTUNG_ID: '',
      ID: '',
      Leistung: data.Leistung,
      Beschreibung: data.Beschreibung,
      Zusatz: '',
      Typ: '0',
      Mitarbeiter: '', //this.rhynoApi.UserAccount.Mitarbeiter,
      MitarbeiterName: '', // this.rhynoApi.UserAccount.Name,
      Kunde: data.Kunde,
      Datum: date.format('YYYY-MM-DD'),
      ProjektID: data.ProjektID,
      ProjektIDExt: data.ProjektIDExt,
      ProjektBezeichnung: data.ProjektBezeichnung,
      Auftrag: '',
      Sprache: 'D',
      VonExtern: '', //
      BisExtern: '', //
      MengeExtern: data.MengeExtern,
      VonIntern: '',
      BisIntern: '',
      MengeIntern: 0, //
      PreisExtern: 0,
      PreisIntern: 0,
      Rabatt: 0,
      Verrechenbar: true,
      VerrechnetAm: '',
      Verrechnet: false,
      Kostenstelle: '',
      Kostentraeger: '',
      BelegpKennung: '',
      Basismengenfaktor: '1',
      Frei1: '',
      Frei2: '',
      FreiDatum: '',
      FreiZahl: '',
      AngelegtAm: '',
      AngelegtVon: 'ap',
      BearbeitetAm: '',
      BearbeitetVon: 'ap',
      Leistungstext: ''
      };

  }
  setProject(data, createMode){
    if (createMode == true ){
      this.leistung.ProjektID = data.Id;
      this.leistung.ProjektIDExt = data.Projekt;
      this.leistung.ProjektBezeichnung = data.Bezeichnung;
      this.leistung.Kunde = data.Kunde;
      this.calculatePrice();
    }else{
      this.leistungEdit.ProjektID = data.Id;
      this.leistungEdit.ProjektIDExt = data.Projekt;
      this.leistungEdit.ProjektBezeichnung = data.Bezeichnung;
      this.leistungEdit.Kunde = data.Kunde;
      this.calculatePriceEdit();
    }

    this.prefillLeistung(createMode);
  }
  setLeistung(data, createMode){
    if (createMode == true ){
      this.leistung.Leistung = data.Artikelnummer;
      this.leistung.Beschreibung = data.Bezeichnung;
      this.calculatePrice();
    }else{
      this.leistungEdit.Leistung = data.Artikelnummer;
      this.leistungEdit.Beschreibung = data.Bezeichnung;
      this.calculatePriceEdit();
    }
  }

  prefillProject(createMode){
    if (this.leistung.ProjektID == ''){
     this.rhynoApi.getProjekt({}).subscribe(
      data => {
        if (data.success && data.data.length == 1){
          this.setProject(data.data[0], createMode)

          console.log(data);
        }
      },
        err => {
        console.log(err);
      },
      () => console.log('Projekte Search Complete')
      );
    }
  }

  prefillLeistung(createMode){
    if (this.leistung.ProjektID != '' && this.leistung.Kunde != ''){
      this.rhynoApi.getLeistungsartikel(this.leistung.Kunde).subscribe(
        data => {
        if (data.success && data.data.length == 1){
          this.leistung.Leistung = data.data[0].Artikelnummer;
          this.leistung.Beschreibung = data.data[0].Bezeichnung;
          
          this.calculatePrice();

          //this.Leistungsartikel = data.data; 
          console.log(data);
        } else {
          // validate the project id in the value field
          let objOfArray = data.data.find(x => x.Artikelnummer === this.leistung.Leistung);
          if (objOfArray == null) {
            this.leistung.Leistung = '';
            this.leistung.Beschreibung = '';
          }
        }
      },
        err => {
        console.log(err);
      },
      () => console.log('Leistungsartikel Search Complete')
      );
    }
  }

  initEditLeistung(data){
    this.leistungEdit = this.initLeistung();

    this.leistungEdit.LEISTUNG_ID  = data.LEISTUNG_ID;
    this.leistungEdit.ID           = data.ID;
    this.leistungEdit.Kunde        = data.Kunde;
    this.leistungEdit.KundeName    = data.KundeName;
    this.leistungEdit.Beschreibung = data.Beschreibung;

    //let date        = new Date(data.Datum);
    let date        = moment(data.Datum);
    //date.setHours(1, 0, 0, 0);

    this.leistungEdit.Datum        = date.format('YYYY-MM-DD'),
    this.leistungEdit.Leistung     = data.Leistung;
    this.leistungEdit.MengeExtern  = data.MengeExtern;
    this.leistungEdit.PreisExtern  = data.PreisExtern;
    this.leistungEdit.Mitarbeiter  = data.Mitarbeiter;
    this.leistungEdit.ProjektIDExt      = data.ProjektIDExt;
    this.leistungEdit.ProjektBezeichnung = data.ProjektBezeichnung;
    this.leistungEdit.ProjektID    = data.ProjektID;
    this.leistungEdit.Verrechnet   = data.Verrechnet;
    this.leistungEdit.MitarbeiterName = data.MitarbeiterName;
    this.leistungEdit.Leistungstext = data.Leistungstext;

  }

  createLeistung(navCtrl):any{
  	this.leistung.VonIntern 	= this.leistung.Datum;
  	this.leistung.BisIntern 	= this.leistung.Datum;
  	this.leistung.VonExtern 	= this.leistung.Datum;
  	this.leistung.BisExtern 	= this.leistung.Datum;

  	this.leistung.MengeIntern 	= this.leistung.MengeExtern;
  	this.leistung.PreisIntern 	= this.leistung.PreisExtern;
  	this.leistung.AngelegtAm 	  = this.leistung.Datum;
  	this.leistung.BearbeitetAm 	= this.leistung.Datum;

  	return this.rhynoApi.createLeistung(this.leistung).subscribe(data => {
  		var respData = JSON.parse(data._body);
        if (respData.success){
        	this.presentToast('Leistung erfasst');
        	this.resetLeistung();
          navCtrl.pop()
          return 'ok'
          //navCtrl.pop();
    	}else{
    		this.presentToast(respData.message);
        return 'error'
    	}
       }, error => {
       	this.presentToast('Es ist ein Fehler aufgetreten');
        console.log(error);// Error getting the data
        return 'error'
      });
  }

   presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 1500,
      position: 'top',
      showCloseButton: false
    });
    toast.present();
  }
  calculatePrice(){
    this.rhynoApi.getPrice(this.leistung.Leistung, this.leistung.Kunde).subscribe(data => {
      if (data.data.length > 0){
        this.leistung.PreisExtern = data.data[0].Preis;
      }else{
        this.presentToast('Preis konnte nicht berechnet werden');
        this.leistung.PreisExtern = 0;
      }
    }, error => {
         this.presentToast('Preis konnte nicht berechnet werden');
        this.leistung.PreisExtern = 0;
      });
  }

  calculatePriceEdit(){
    this.rhynoApi.getPrice(this.leistungEdit.Leistung, this.leistungEdit.Kunde).subscribe(data => {
      if (data.data.length > 0){
        this.leistungEdit.PreisExtern = data.data[0].Preis;
      }else{
        //this.presentToast('Preis konnte nicht berechnet werden');
        this.leistungEdit.PreisExtern = 0;
      }
    }, error => {
         //this.presentToast('Preis konnte nicht berechnet werden');
        this.leistungEdit.PreisExtern = 0;
      });
  }

  changeLeistung():any{
    this.leistungEdit.VonIntern   = this.leistungEdit.Datum;
    this.leistungEdit.BisIntern   = this.leistungEdit.Datum;
    this.leistungEdit.VonExtern   = this.leistungEdit.Datum;
    this.leistungEdit.BisExtern   = this.leistungEdit.Datum;

    this.leistungEdit.MengeIntern   = this.leistungEdit.MengeExtern;
    this.leistungEdit.PreisIntern   = this.leistungEdit.PreisExtern;
    this.leistungEdit.AngelegtAm   = this.leistungEdit.Datum;
    this.leistungEdit.BearbeitetAm   = this.leistungEdit.Datum;

    let result = this.rhynoApi.changeLeistung(this.leistungEdit);
    result.subscribe(data => {
      var respData = JSON.parse(data._body);
        if (respData.success){
          this.presentToast('Leistung geändert');
          this.leistungEdit = this.initLeistung();

      }else{
        this.presentToast(respData.message);
      }
    }, error => {
         this.presentToast('Es ist ein Fehler aufgetreten');
        console.log(error);// Error getting the data
      }
    );
    return result;

  }
  deleteLeistung():any{
    let result = this.rhynoApi.deleteLeistung(this.leistungEdit.LEISTUNG_ID);
    result.subscribe(data => {
      var respData = JSON.parse(data._body);
        if (respData.success){
          this.presentToast('Leistung gelöscht');
          this.leistungEdit = this.initLeistung();

      }else{
        this.presentToast(respData.message);
      }
    }, error => {
         this.presentToast('Es ist ein Fehler aufgetreten');
        console.log(error);// Error getting the data
      }
    );
    return result;

    //this.presentToast('Leistung gelöscht');
    //this.leistungEdit = this.initLeistung();
  }
}



// WEBPACK FOOTER //
// ./src/providers/leistung/leistung.ts